<template>
  <div id="app">
    <main-header></main-header>
    <notifications group="foo" classes="my-notify" />
    <router-view />
  </div>
</template>

<script>
import MainHeader from "./components/header/MainHeader.vue";
export default {
  components: { MainHeader },
  name: "App"
};
</script>

<style>
#app {
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.vue-notification-template {
  background: #027953;
}

.my-notify {
  width: 63%;
  padding: 3%;
  height: 10%;
  font-family: "Inter", sans-serif;
  background: #027953 !important;
  color: #ffffff !important;
  .notification-title {
    background: #027953 !important;
    color: #ffffff !important;
    font-weight: bold !important;
  }

  .notification-content {
    background: #027953 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue